import { render, staticRenderFns } from "./ServeCopyOfOrderOnOtherPartyOther.vue?vue&type=template&id=6475b87e"
import script from "./ServeCopyOfOrderOnOtherPartyOther.vue?vue&type=script&lang=ts"
export * from "./ServeCopyOfOrderOnOtherPartyOther.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports